// Solo afecta la presentación; conserva los identificadores para conciliar.
export const getConciliationAccountDisplayNumber = (item, number) => {
  const isCajaPrincipal = [item?.nombreCuentaBanco, item?.nombreBanco, item?.name]
    .some(name => String(name ?? '').trim().toLowerCase() === 'caja principal')

  return isCajaPrincipal ? null : number
}
